import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormCloudProvisionerTemplateResponse } from '~/models/Commons ';

interface State {
    cloudProvisionerTemplates: FormCloudProvisionerTemplateResponse[];
}

const initialState: State = {
    cloudProvisionerTemplates: [],
};

const CloudProvisionerTemplateSlice = createSlice({
    name: 'cloudProvisionerTemplate',
    initialState,
    reducers: {
        SET_CLOUDPROVISIONERTEMPLATE(state, { payload }: PayloadAction<FormCloudProvisionerTemplateResponse[]>) {
            state.cloudProvisionerTemplates = payload;
        },
        DELETE_CLOUDPROVISIONERTEMPLATE_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.cloudProvisionerTemplates)) {
                state.cloudProvisionerTemplates = [];
            }
            state.cloudProvisionerTemplates = state.cloudProvisionerTemplates.filter(
                (item) => item.id !== payload
            );
        },
        ADD_CLOUDPROVISIONERTEMPLATE(state, { payload }: PayloadAction<FormCloudProvisionerTemplateResponse>) {
            state.cloudProvisionerTemplates = [...state.cloudProvisionerTemplates, payload];
        },
        PATCH_CLOUDPROVISIONERTEMPLATE(state, { payload }: PayloadAction<FormCloudProvisionerTemplateResponse>) {
            const items = [...state.cloudProvisionerTemplates];
            const index = items.findIndex(({ id }) => id === payload.id);
            if (index < 0) return;
            items[index] = { ...payload };
            state.cloudProvisionerTemplates = items;
        },
    },
});

export const {
    SET_CLOUDPROVISIONERTEMPLATE,
    DELETE_CLOUDPROVISIONERTEMPLATE_BYID,
    ADD_CLOUDPROVISIONERTEMPLATE,
    PATCH_CLOUDPROVISIONERTEMPLATE,
} = CloudProvisionerTemplateSlice.actions;

export default CloudProvisionerTemplateSlice.reducer;
